<template>
  <section> 
    <b-row>
      <b-col>
        <b-card
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Historial pacientes
            </div>        
          </template>
            <b-row  style="width:100%">
                <sw-searchs
                  label="Seleccionar paciente"
                  list="datos_pacientes"
                  :lg="6"
                  modalSize="lg"
                  modalTitle="Crear Nuevo Paciente"
                  modalVariant="primary"
                  @input="searchsBackend"
                  >
                  <template v-slot:modal>
                    <sw-modalpaciente @save="saveForm">
                    </sw-modalpaciente> 
                  </template>
                </sw-searchs>
            </b-row>     
            <b-row v-if="searchSw.value!==''">
              <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="historial_pacientes"
                    :dataRoute="searchSw.value"
                    @save="saveForm"
                    >
                    <template v-slot:modal>
                      <sw-modalexamen 
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm"
                        >
                      </sw-modalexamen>
                    </template>
                  </sw-tableget>                  
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row>                    
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalinactive from '@/components/modals/inactive.vue'
import SwModalexamen from '@/components/modals/examen.vue'


export default { 
  name: "datos_examens",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalinactive,
  SwModalexamen,
  SwSearchs     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>

